import {
	FontAwesomeIcon as I,
	FontAwesomeIconProps,
} from '@fortawesome/react-fontawesome';
import React from 'react';

interface IIconProps extends FontAwesomeIconProps {}

const Icon: React.FC<IIconProps> = (props) => {
	return <I {...props} />;
};

export default Icon;
